import { BaseFiltroPagDTO } from "./base-dto";

export class AcompanhamentoPacienteFiltroDTO extends BaseFiltroPagDTO {
  tpFiltro: string;
  situacao: string;
  validacao: string;
  idUnidade: number;
  diasPassado: number;
  diasFuturo: number;
  nmPaciente: string;
  tpBolsa: string;
}